module.exports = __webpack_public_path__ + "img/nevi_teaser_desktop_why_electrify.071954bb.png";